import { useEffect, useState } from "react";
import { Eye, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { compact } from "@/lib/format";

const when = (iso) => {
  if (!iso) return "";
  const then = new Date(iso);
  const mins = Math.round((Date.now() - then.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hr ago`;
  const days = Math.round(hrs / 24);
  if (days < 7) return `${days} day(s) ago`;
  return then.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
};

export const PortalActivity = ({ symbol }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/portal/activity", { params: { limit: 8 } })
      .then((res) => setData(res.data))
      .catch(() => setData({ views: [], total_views: 0, live_links: 0 }));
  }, []);

  return (
    <div className="surface min-w-0" data-testid="portal-activity">
      <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
        <h2 className="font-serif text-xl text-slate-900">Account pages opened</h2>
        {data ? (
          <span className="label-caps" data-testid="portal-activity-live-count">
            {data.live_links} live
          </span>
        ) : null}
      </div>
      {!data ? (
        <div className="flex h-24 items-center justify-center">
          <Loader2 className="h-4 w-4 animate-spin text-slate-400" />
        </div>
      ) : data.views.length === 0 ? (
        <p className="px-6 py-8 text-sm text-slate-500" data-testid="portal-activity-empty">
          No one has opened an account page yet. Share a link from a contact or a law firm and reads
          will show up here.
        </p>
      ) : (
        <div className="divide-y divide-slate-100">
          {data.views.map((v) => (
            <div
              key={v.view_id}
              className="flex items-center justify-between gap-4 px-6 py-3.5"
              data-testid={`portal-view-${v.view_id}`}
            >
              <div className="min-w-0">
                <p className="truncate text-[13px] text-slate-800">
                  {v.account_name || "Account page"}
                </p>
                <p className="text-[11px] text-slate-400">
                  {v.scope === "firm" ? "Firm page" : "Lawyer page"} · {when(v.at)}
                </p>
              </div>
              <div className="flex items-center gap-3 text-right">
                <span className="num text-[12px] text-slate-600">
                  {compact(v.outstanding, symbol)}
                </span>
                <Eye className="h-3.5 w-3.5 shrink-0 text-slate-300" strokeWidth={1.8} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
